import { combineReducers } from 'redux';
import accounts from 'granite-admin/accounts/ducks';
import organisations from 'granite-admin/organisations/ducks';
import common from 'granite-admin/common/ducks';

// This file will contain your all custom ducks
import * as appDucks from 'ducks';
const appReducer = combineReducers({
  accounts,
  organisations,
  common,
  ...appDucks
});
const rootReducer = (state, action) => {
  let newState = state;
  if (action.type === 'accounts/user/RESET_STATE') {
    newState = undefined;
  }
  return appReducer(newState, action);
};
export default rootReducer;